async function elementReadyWithMutationObserver(selector, timeoutMs) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector)
    if (element) {
      resolve(element)
      return
    }
    const observer = new MutationObserver((mutationRecords, observer) => {
      const element = document.querySelector(selector)
      if (element) {
        resolve(element)
        observer.disconnect()
      }
    })
    setTimeout(() => {
      reject(new Error(`elementReady timed out after ${timeoutMs}ms`))
      observer.disconnect()
    }, timeoutMs)
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  })
}

async function elementReadyWithInterval(selector, intervalMs, timeoutMs) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector)
    if (element) {
      resolve(element)
      return
    }
    const timeout = setTimeout(() => {
      reject(new Error(`elementReady timed out after ${timeoutMs}ms`))
    }, timeoutMs)
    const interval = setInterval(() => {
      const element = document.querySelector(selector)
      if (element) {
        clearTimeout(timeout)
        clearInterval(interval)
        resolve(element)
      }
    }, intervalMs)
  })
}

export default async function elementReady(elementSelector, { useMutationObserver = true, intervalMs = 50, timeoutMs = 1000 } = {}) {
  return new Promise((resolve, reject) => {
    if (useMutationObserver) {
      elementReadyWithMutationObserver(elementSelector, timeoutMs)
        .then(resolve)
        .catch(reject)
    }
    else {
      elementReadyWithInterval(elementSelector, intervalMs, timeoutMs)
        .then(resolve)
        .catch(reject)
    }
  })
}
